import styled from "styled-components";
import Container from "@material-ui/core/Container";

const Wrapper = styled(Container)`
  margin-top: 80px;
  height: 100%;
  position: relative;
  max-width: 1400px !important;

  .date-time-container {
    margin-top: 15px;

    .date--filter--wrapper {
      display: flex;
    }
  }
  .date--time--wrapper {
    flex: 1 1 auto;
    display: flex;
    .clock--wrapper {
      margin-right: 10px;
    }
    ul.clock {
      background: #fff;
      list-style: none;
      line-height: normal;
      padding-bottom: 0;
      margin-bottom: 0;
      line-height: 50px;
      height: 50px;
      li {
        display: inline;
        font-weight: 100;
        font-size: 28px;
        color: ${(props) => props.theme.colors.primary.main};
        text-shadow: -1px 0 #f04f38, 0 1px #f04f38, 1px 0 #f04f38, 0 -1px #f04f38;
      }
    }

    .clock-day {
      font-weight: 400;
      padding-bottom: 3px;
      display: block;
      font-size: 12.6px;
      letter-spacing: 2px;
      color: ${(props) => props.theme.colors.primary.main};
    }
    .clock--date {
      color: ${(props) => props.theme.colors.primary.main};
      font-size: 16px;
      letter-spacing: 0.48px;
    }
    .ampm {
      padding-left: 15px;
    }

    .point {
      position: relative;
      font-size: 30px;
      color: #f04f38;
    }

    .date--wrapper {
      color: #626262;
      font-size: 17px;
      font-weight: 700;
      text-transform: uppercase;
      border-left: 1px solid RGBA(0, 0, 0, 0.12);
      padding: 7.5px 0 7.5px 20px;
    }
  }

  #new_stuff {
    bottom: 50%;
    text-align: center;
    position: fixed;
    z-index: 27;
    .newVideo {
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0.38px;
      line-height: 16px;
      cursor: pointer;
      background: RGBA(0, 0, 0, 0.54);
      height: 24px;
      width: 124px;
      color: #fff;
      border-radius: 4px;
      box-shadow: 0 0 7px 0 rgba(51, 51, 51, 0.33);

      &:hover {
        background: #c22c0c;
        color: #fff;
      }
    }
  }

  @media screen and (min-width: 1692px) {
    #new_stuff {
      left: 46px;
    }
  }
  @media screen and (max-width: 1691px) {
    #new_stuff {
      right: 22px;
    }
  }

  @media screen and (max-width: 767px) {
    .date-time-container {
      .date--filter--wrapper {
        display: block;
      }
    }
    .date--time--wrapper {
      .date--wrapper {
        font-size: 12px;
        color: ${(props) => props.theme.colors.primary.main};
      }
    }
  }
`;

export default Wrapper;
